import { useLocalStorage } from "@jugl-web/utils/hooks/useStorage";
import { ACTIVE_TIME_TRACKING_NOTES_BY_LOG_ID_KEY } from "@jugl-web/utils/storage";
import { useCallback } from "react";

/**
 * Hook to manage caching of active time tracking notes
 */
export const useActiveTimeTrackingNotesCache = () => {
  const [cachedNotesByLogId, setCachedNotesByLogId] = useLocalStorage<
    Record<string, string>
  >(ACTIVE_TIME_TRACKING_NOTES_BY_LOG_ID_KEY, {});

  const getCachedNotes = useCallback(
    (timeLogId: string) => {
      return cachedNotesByLogId[timeLogId] ?? "";
    },
    [cachedNotesByLogId]
  );

  const cacheNotes = useCallback(
    (timeLogId: string, notes: string) => {
      setCachedNotesByLogId((prev) => ({
        ...prev,
        [timeLogId]: notes,
      }));
    },
    [setCachedNotesByLogId]
  );

  const clearCachedNotes = useCallback(() => {
    setCachedNotesByLogId({});
  }, [setCachedNotesByLogId]);

  return {
    getCachedNotes,
    cacheNotes,
    clearCachedNotes,
  };
};
